import { FC } from "react";
import { ISurvey, ISurveyAnswer, SurveyAnswerType } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";
import { makeStyles, shorthands, Subtitle2, Title2 } from "@fluentui/react-components";
import SurveyAnswerView from "./SurveyAnswerView";

const styles = makeStyles({
    surveyContainer: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap('10px'),
    }
});

export interface SurveyViewProps {
    surveyModel?: ISurvey;
    onAnswerChange: (answer: ISurveyAnswer) => void;
}

const SurveyView: FC<SurveyViewProps> = ({ surveyModel, onAnswerChange }: SurveyViewProps) => {
    const classes = styles();

    const answerChanged = (id: string, value: string, type :SurveyAnswerType) => {
        onAnswerChange({id, value, type});
    };

    // create the survey based on the survey model
    return surveyModel && 
        <div className={classes.surveyContainer}>
            <Title2 align="center">{surveyModel.title}</Title2>
            <Subtitle2>{surveyModel.subtitle}</Subtitle2>
            {
                surveyModel.questions?.map((q, index) => (
                    <SurveyAnswerView key={`question_${q.id}`} id={q.id!} questionNumber={index + 1} question={q.text!} answerType={q.type!} onAnswer={answerChanged} options={q.answerOptions} />
                ))
            }
        </div>;
}

export default SurveyView;